module.exports = __webpack_public_path__ + "img/add.df55a474.svg";